// src/pages/ContactPage.tsx
import { motion } from 'framer-motion';
import ContactForm from '@/components/ContactForm';
import {
  SiFacebook,
  SiGithub,
  SiInstagram,
  SiX,
  SiWhatsapp,
} from '@icons-pack/react-simple-icons';
import PageHeader from '@/components/PageHeader';

// WhatsApp Business number (Cloud API) - digits only, used to build the wa.me link
const WHATSAPP_NUMBER = '15553162280';
const WHATSAPP_DISPLAY = '+1 (555) 316-2280';
const WHATSAPP_LINK = `https://wa.me/${WHATSAPP_NUMBER}`;

const ContactPage = () => {
  return (
    <div>
      {/* Use the new PageHeader component */}
      <PageHeader
        title="Let's discuss your next idea"
        // No description needed here as we have detailed content below
      />

      <div className="container mx-auto py-20 bg-white px-4 mb-10">
        {/* Greeting text */}
        <motion.div
          className="max-w-2xl"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}>
          <p className="text-2xl md:text-3xl text-gray-700 leading-relaxed">
            Whether you have a question about our services, pricing, or just
            want to say hello, we're here to help.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 mx-auto text-left my-20">
          {/* Left Column - Contact Information */}
          <motion.div
            className="space-y-10"
            initial={{ opacity: 0, x: -30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}>
            {/* Email */}
            <div>
              <h3 className="text-lg font-semibold mb-2">Email Us</h3>
              <a
                href="mailto:hello@hoptira.com"
                className="text-xl text-secondary hover:opacity-80 transition-opacity">
                hello@hoptira.com
              </a>
            </div>

            {/* WhatsApp */}
            <div>
              <h3 className="text-lg font-semibold mb-2">WhatsApp Us</h3>
              <a
                href={WHATSAPP_LINK}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-xl text-gray-500 hover:opacity-80 transition-opacity">
                <SiWhatsapp size={20} />
                {WHATSAPP_DISPLAY}
              </a>
            </div>

            {/* Address */}
            <div>
              <h3 className="text-lg font-semibold mb-2">Write Us</h3>
              <p className="text-xl text-gray-500">
                Hoptira Labs LLC
                <br />
                30 N Gould St Ste R,
                <br />
                Sheridan, WY 82801
              </p>
            </div>

            {/* Social media icons */}
            <div>
              <h3 className="text-lg font-semibold mb-2">Follow Us</h3>
              <div className="flex space-x-6 mt-2">
                <a
                  href="https://facebook.com/hoptira"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-500 hover:text-blue-600 transition-colors">
                  <SiFacebook size={24} />
                </a>
                <a
                  href="https://instagram.com/hoptiralabs"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-500 hover:text-pink-600 transition-colors">
                  <SiInstagram size={24} />
                </a>
                <a
                  href="https://twitter.com/hoptira"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-500 hover:text-black transition-colors">
                  <SiX size={24} />
                </a>
                <a
                  href="https://github.com/hoptira"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-500 hover:text-black transition-colors">
                  <SiGithub size={24} />
                </a>
              </div>
            </div>
          </motion.div>

          {/* Right Column - Contact Form */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}>
            <ContactForm />
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
